import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EditorModule } from '@progress/kendo-angular-editor';
import { ExhibitDesignerComponent } from './exhibits/exhibit-designer/exhibit-designer.component';
import { MyExhibitsComponent } from './exhibits/my-exhibits.component';
import { CallForPostersComponent } from './posters/call-for-posters/call-for-posters.component';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';
import { AuthorCourseComponent } from './my-account/author-course/author-course.component';
import { UploadCourseVideoComponent } from './my-account/author-course/upload-course-video.component';
import { ChangePasswordComponent } from './my-account/change-password/change-password.component';
import { MyEventsComponent } from './my-account/events/my-events.component';
import { LibraryComponent } from './my-account/library/library.component';
import { MyListingsComponent } from './my-account/listings/my-listings.component';
import { MyLiveEventsComponent } from './my-account/my-live-events/my-live-events.component';
import { ScheduleEventComponent } from './my-account/my-live-events/schedule-event/schedule-event.component';
import { PaymentsComponent } from './my-account/payments/payments.component';
import { BankingContainerComponent } from './my-account/payments/banking-container.component';
import { MyPostersComponent } from './my-account/posters/my-posters.component';
import { ProfileComponent } from './my-account/profile/profile.component';
import { ReferralsComponent } from './my-account/referrals/referrals.component';
import { SalesHistoryComponent } from './my-account/sales-history/sales-history.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CalendarDOMService, DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ClipboardModule } from 'ngx-clipboard';
import { SharedAccountConferenceModule } from './shared-account-conference.module';
import { MyPaperSubmissionsComponent } from './my-account/paper-submissions/my-paper-submissions.component';
import { ManageExhibitUsersComponent } from './exhibits/manage-exhibit-users/manage-exhibit-users.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ApaAssessmentModalComponent } from './my-account/ceu-history/apa-assessment-modal.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { PaginatorModule } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';
import { UserCertificationsComponent } from './my-account/certifications/user-certifications.component';
import { AddUserCertificationModalComponent } from './my-account/certifications/add-user-certification-modal.component';
import { CeuHistoryComponent } from './my-account/ceu-history/ceu-history.component';
import { ConferenceCertificatesComponent } from './my-account/ceu-history/conference-certificates.component';
import { IndividualCertificatesComponent } from './my-account/ceu-history/individual-certificates.component';
import { ConferenceEventSummariesComponent } from './my-account/ceu-history/conference-event-summaries.component';
import { ViewConferenceCertificateComponent } from './my-account/ceu-history/view-conference-certificate.component';
import { ResolveCEUsModalComponent } from './my-account/ceu-history/resolve-ceus-modal.component';
import { TooltipModule } from 'primeng/tooltip';
import { ViewIndividualCertificateComponent } from './my-account/ceu-history/view-individual-certificate.component';
import { TeachingCeuSummariesComponent } from './my-account/ceu-history/teaching-ceu-summaries.component';
import { TeachingCertificatesComponent } from './my-account/ceu-history/teaching-certificates.component';
import { PurchaseCeusModalComponent } from './my-account/ceu-history/purchase-ceus-modal.component';
import { MyConferenceExpensesComponent } from './my-account/payments/my-conference-expenses.component';
import { MyExpensesForConferenceComponent } from './my-account/payments/my-expenses-for-conference.component';
import { EditMyExpenseModalComponent } from './my-account/payments/edit-my-expense-modal.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { PDFExportModule } from "@progress/kendo-angular-pdf-export";
import { UserSubscriptionComponent } from "./my-account/billing/user-subscription.component";
import { AddUserSubscriptionComponent } from "./my-account/billing/addusersubscription.component";
import { MyConferencesComponent } from './my-account/events/my-conferences.component';
import { MyIndividualEventsComponent } from './my-account/events/my-individual-events.component';
import { MyConferenceEventsComponent } from './my-account/events/my-conference-events.component';
import { MyConferenceContainerComponent } from './my-account/events/my-conference-container.component';
import { MyConferenceFavoritesComponent } from './my-account/events/my-conference-favorites.component';
import { CeuEvalModalComponent } from "./my-account/ceu-history/ceu-eval-modal.component";
import { SurveyModule } from "survey-angular-ui";


@NgModule({
  declarations:[
    ProfileComponent,
    PaymentsComponent,
    LibraryComponent,
    MyEventsComponent,
    ReferralsComponent,
    MyExhibitsComponent,
    SalesHistoryComponent,
    MyListingsComponent,
    MyPaperSubmissionsComponent,
    ChangePasswordComponent,
    CeuEvalModalComponent,
    CeuHistoryComponent,
    AuthorCourseComponent,
    ManageExhibitUsersComponent,
    UploadCourseVideoComponent,
    ApaAssessmentModalComponent,
    UserCertificationsComponent,
    ConferenceCertificatesComponent,
    AddUserCertificationModalComponent,
    IndividualCertificatesComponent,
    ConferenceEventSummariesComponent,
    ViewConferenceCertificateComponent,
    ViewIndividualCertificateComponent,
    ResolveCEUsModalComponent,
    TeachingCeuSummariesComponent,
    TeachingCertificatesComponent,
    PurchaseCeusModalComponent,
    BankingContainerComponent,
    MyExpensesForConferenceComponent,
    MyConferenceExpensesComponent,
    EditMyExpenseModalComponent,
    UserSubscriptionComponent,
    AddUserSubscriptionComponent,
    MyConferencesComponent,
    MyIndividualEventsComponent,
    MyConferenceContainerComponent,
    MyConferenceEventsComponent,
    MyConferenceFavoritesComponent

  ],
  imports: [
    InputsModule,
    CKEditorModule,
    TooltipModule,
    DropDownsModule,
    SkeletonModule,
    ClipboardModule,
    DateInputsModule,
    PaginatorModule,
    NgbModalModule,
    PDFExportModule,
    ImageCropperModule,
    ApplicationPipesModule.forRoot(),

    SharedAccountConferenceModule,
    RouterModule.forChild([
      {
        path: '',
        redirectTo: 'profile',
        pathMatch: 'full'
      },
      {
        path: 'profile',
        component: ProfileComponent,
        data: {title: 'Profile - My Account'}
      },
      {
        path: 'payments',
        component: BankingContainerComponent,
        data: {
          oauth: false,
          title: 'Payments - My Account'
        },
        children: [
          {
            path: '',
            redirectTo: 'banking',
            pathMatch: 'full'
          },
          {
            path: 'banking',
            component: PaymentsComponent,
            data: {
              oauth: false,
              title: 'Payments - My Account'
            }
          },
          {
            path: 'expenses',
            component: MyConferenceExpensesComponent,
            data: {
              oauth: false,
              title: 'Conference Expenses - My Account'
            }
          },
          {
            path: 'expenses/:conferenceId',
            component: MyExpensesForConferenceComponent,
            data: {
              oauth: false,
              title: 'Conference Expenses - My Account'
            }
          },
        ]
      },
      {
        path: 'stripe-complete-oauth',
        component: PaymentsComponent,
        data: {oauth: true}
      },
      {
        path: 'library',
        component: LibraryComponent,
        data: {title: 'My Course Library'}
      },
      {
        path: 'live-events',
        component: MyLiveEventsComponent,
        data: {title: 'My Live Events'}
      },
      {
        path: 'live-events/schedule',
        component: ScheduleEventComponent,
        data: {title: 'Schedule an Event - My Account'}
      },
      {
        path: 'live-events/:id/edit',
        component: ScheduleEventComponent,
        data: {title: 'Edit a scheduled Event - My Account'}
      },
      {
        path: 'events',
        component: MyEventsComponent,
        data: {title: 'Registered Events'},
        children: [
          {
            path: '',
            redirectTo: 'conferences',
            pathMatch: 'full'
          },
          {
            path: 'conferences',
            component: MyConferencesComponent,
            data: {title: 'Conferences - My Account'}
          },
          {
            path: 'conferences/:conferenceId',
            component: MyConferenceContainerComponent,
            data: {title: 'Conference Events - My Account'},
            children: [
              {
                path: '',
                redirectTo: 'schedule',
                pathMatch: 'full'
              },
              {
                path: 'schedule',
                component: MyConferenceEventsComponent,
                data: {title: 'Conference Events - My Account'}
              },
              {
                path: 'my-schedule',
                component: MyConferenceFavoritesComponent,
                data: {title: 'Conference Events - My Account'}
              },
            ]
          },
          {
            path: 'conferences/:conferenceId/schedule',
            component: MyConferenceEventsComponent,
            data: {title: 'Conference Events - My Account'}
          },
          {
            path: 'individual-events',
            component: MyIndividualEventsComponent,
            data: {title: 'A La Carte Events - My Account'}
          },
        ]
      },
      {
        path: 'posters',
        component: MyPostersComponent,
        data: {title: 'My Posters - My Account'}
      },
      {
        path: 'posters/:id/edit',
        component: CallForPostersComponent,
        data: {title: 'Add/Edit Poster'}
      },
      {
        path: 'referrals',
        component: ReferralsComponent,
        data: {title: 'My Referrals'}
      },
      {
        path: 'exhibits',
        component: MyExhibitsComponent,
        data: {title: 'My Exhibits'}
      },
      {
        path: 'subscription',
        component: UserSubscriptionComponent,
        data: {title: 'Subscription'}
      },
      {
        path: 'exhibits/:id/designer',
        component: ExhibitDesignerComponent,
        data: {title: 'Exhibit Designer'}
      },
      {
        path: 'exhibits/:id/users',
        component: ManageExhibitUsersComponent,
        data: {title: 'Exhibit Users'}
      },
      {
        path: 'call-for-posters',
        component: CallForPostersComponent,
        data: {title: 'Call For Posters'}
      },
      {
        path: 'paper-submissions',
        component: MyPaperSubmissionsComponent,
        data: {title: 'My Paper Submissions'}
      },
      {
        path: 'sales-history',
        component: SalesHistoryComponent,
        data: {title: 'Sales History'}
      },
      {
        path: 'listings',
        component: MyListingsComponent,
        data: {title: 'My Courses for Sale'}
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        data: {title: 'Change Password'}
      },
      {
        path: 'ceus',
        component: CeuHistoryComponent,
        data: {title: 'CEU History - My Account'},
        children: [
          {
            path: '',
            redirectTo: 'conference-ceus',
            pathMatch: 'full'
          },
          {
            path: 'certifications',
            component: UserCertificationsComponent,
            data: {title: 'Certifications - My Account'}
          },
          {
            path: 'conference-ceus',
            component: ConferenceCertificatesComponent,
            data: {title: 'Certifications - My Account'}
          },
          {
            path: 'conference-ceus/:conferenceId/event-summaries',
            component: ConferenceEventSummariesComponent,
            data: {title: 'Certifications - My Account'}
          },
          {
            path: 'conference-ceus/:conferenceId/certificates',
            component: ViewConferenceCertificateComponent,
            data: {title: 'Certifications - My Account'}
          },
          {
            path: 'conference-ceus/:conferenceId/certificates/:courseEventId',
            component: ViewIndividualCertificateComponent,
            data: {title: 'Individual Certificate - My Account'}
          },
          {
            path: 'individual-ceus',
            component: IndividualCertificatesComponent,
            data: {title: 'Certifications - My Account'}
          },
          {
            path: 'individual-ceus/:courseEventId',
            component: ViewIndividualCertificateComponent,
            data: {title: 'Certifications - My Account'}
          },
          {
            path: 'teaching-ceus',
            component: TeachingCeuSummariesComponent,
            data: {title: 'Certifications - My Account'}
          },
          {
            path: 'teaching-ceus/:courseEventId',
            component: TeachingCertificatesComponent,
            data: {title: 'Certifications - My Account'}
          },
        ]
      },
      {
        path: 'certifications',
        component: UserCertificationsComponent,
        data: {title: 'User Certifications - My Account'}
      },
      {
        path: 'author-course',
        component: AuthorCourseComponent,
        data: {title: 'Author Course'}
      },
      {
        path: 'author-course/:courseId/upload',
        component: UploadCourseVideoComponent,
        data: {title: 'Upload Asset - Author Course'}
      },
    ]),
    SurveyModule
  ],
  exports:[RouterModule]
})
export class MyAccountModule{}
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
